import { FC } from "react";

interface ExpertiseProps {
  
}
 
const Expertise: FC<ExpertiseProps> = () => {
  return (
    <div
      className="bloc d-bloc bloc-fill-screen bloc-bg-texture texture-darken-strong"
      id="expertise-section"
    >
      <div className="container">
        <div className="row">
          <div className="offset-lg-1 col-lg-10">
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h1 className="mg-md text-lg-center h1-about-style text-white">
                  Our Expertise
                </h1>
              </div>
            </div>
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h2 className="mg-md text-lg-center h3-about-style text-white fix-header">
                  Your best IT investment.
                </h2>
              </div>
            </div>
            <p className="text-lg-center p-7-style scroll-fx-up-in mt-md-4 mt-sm-2">
              We are largely responsible for the design, corresponding
              implementation and further development of web applications. In
              addition, as .NET software engineers, we are in charge of the
              analysis of specific problems, potentially providing or developing
              the appropriate system requirements. These system requirements are
              then implemented in the design mix of interfaces and components.
              Normally, we work on concrete projects that involve the
              development of web applications solutions based on various
              technologies. In addition, we also take on a variety of tasks,
              from simple things like bug fixing on an existing product or
              application, to completely building a new one from scratch.
            </p>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-4 col-lg-3 offset-lg-1 align-self-center animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <div className="card">
              <div className="card-header">
                <h3 className="mg-clear text-center h3-languages-style">
                  Languages
                </h3>
              </div>
              <img
                src="img/coding.jpg"
                className="img-fluid mx-auto d-block"
                alt="placeholder"
              />
              <div className="card-body">
                <ul className="list-unstyled">
                  <li>
                    <p className="text-center p-style">C# 10.0</p>
                  </li>
                  <li>
                    <p className="text-center p-bloc-3-style">
                      JavaScript (ES6)
                    </p>
                  </li>
                  <li>
                    <p className="text-center p-9-style">TypeScript 4</p>
                  </li>
                  <li>
                    <p className="text-center p-10-style">T-SQL</p>
                    <p className="text-center p-11-style">Python</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="col-md-4 mt-3 mt-md-0 col-lg-4 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <div className="card">
              <div className="card-header">
                <h3 className="mg-clear text-center h3-frameworks-style">
                  Frameworks
                </h3>
              </div>
              <img
                src="img/frameworks.png"
                className="img-fluid mx-auto d-block"
                alt="placeholder"
              />
              <div className="card-body">
                <ul className="list-unstyled">
                  <li>
                    <p className="text-center p-12-style">React 18</p>
                  </li>
                  <li>
                    <p className="text-center p-13-style">Angular 14</p>
                  </li>
                  <li>
                    <p className="text-center p-14-style">.NET 8</p>
                  </li>
                  <li>
                    <p className="text-center p-15-style">
                      Entity Framework Core 8
                    </p>
                    <p className="text-center p-16-style">.NET Framework 4.8</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="col-md-4 mt-3 mt-md-0 col-lg-3 align-self-center animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <div className="card">
              <div className="card-header">
                <h3 className="mg-clear text-center h3-design-style">Design</h3>
              </div>
              <img
                src="img/design.jpg"
                className="img-fluid mx-auto d-block"
                alt="placeholder"
              />
              <div className="card-body">
                <ul className="list-unstyled">
                  <li>
                    <p className="text-center p-17-style">Bootstrap 4</p>
                  </li>
                  <li>
                    <p className="text-center p-18-style">Material UI</p>
                  </li>
                  <li>
                    <p className="text-center p-19-style">HTML5/CSS3</p>
                  </li>
                  <li>
                    <p className="text-center p-20-style">LESS/SASS</p>
                    <p className="text-center p-21-style">Resonsive Design</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
 
export default Expertise;